module.exports = __webpack_public_path__ + "static/info1-65a9a75f8e8032e93becb83c60fdc645.png";